import React, { useCallback, useState } from 'react'

import { type WidgetDTO } from '../../../../../model/Widget'

import { ButtonEditMode, type ButtonFormValues } from './edit/ButtonEditMode'
import { ButtonPreview } from './preview/ButtonPreview'

import './WidgetButton.scss'

interface WidgetButtonProps {
  widget: WidgetDTO
  isEditable?: boolean
  onSave?: (values: Partial<WidgetDTO>) => Promise<void>
  onDelete?: () => void
  onCancel?: () => void
}

const WidgetButton = ({
  widget,
  isEditable = false,
  onSave,
  onDelete,
  onCancel,
}: WidgetButtonProps) => {
  const [isEditMode, setIsEditMode] = useState(!!widget.empty_p)

  const handleEdit = useCallback(() => {
    setIsEditMode(true)
  }, [])

  const handleCancel = useCallback(() => {
    onCancel?.()
    if (!widget.empty_p) {
      setIsEditMode(false)
    }
  }, [onCancel, widget.empty_p])

  const handleSubmit = useCallback(
    async (values: ButtonFormValues) => {
      await onSave?.(values)
      setIsEditMode(false)
    },
    [onSave]
  )

  const handleDelete = useCallback(() => {
    onDelete?.()
  }, [onDelete])

  return isEditMode ? (
    <ButtonEditMode
      widget={widget}
      onSave={handleSubmit}
      onCancel={handleCancel}
    />
  ) : (
    <ButtonPreview
      widget={widget}
      isEditable={isEditable}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
    />
  )
}

export { WidgetButton }
